export default __webpack_public_path__ + "static/media/14B.020.d3abbcd1.png";